<div class="alert alert-app-level alert-warning" role="alert" *ngIf="settings.edit && service.showBanner">
  <div class="alert-items">
    <div class="alert-item static">
      <div class="alert-icon-wrapper">
        <cds-icon class="pen" shape="wrench"></cds-icon>
      </div>
      <div class="alert-text">
        {{'Header.NotReviewed' | translate}}
      </div>
      <div class="alert-actions">
        <button class="btn alert-action">{{'Actions.Review'
          |translate}}</button>
      </div>
    </div>
  </div>
</div>
